export enum ChannelDenoiserLevel {
	Low = 'LOW',
	Medium = 'MEDIUM',
	High = 'HIGH'
}
